import styles from './RTextInput.module.css';

import { InputAdornment, OutlinedTextFieldProps, Stack, TextField, Typography } from '@mui/material';
import { ChangeEvent, ReactNode } from 'react';
import { ExclamationMarkIcon } from '@icons/ExclamationMarkIcon';

interface Props extends Omit<OutlinedTextFieldProps, 'variant'> {
	onChange: (value: any) => void;
	variant?: 'outlined' | 'filled' | 'standard';
	isValid?: boolean;
	startIcon?: ReactNode;
	endIcon?: ReactNode;
	errorMessage?: string;
}

export const RTextInput = ({
	required,
	title,
	isValid,
	value,
	onChange,
	startIcon,
	endIcon,
	variant = 'outlined',
	errorMessage,
	...rest
}: Props) => {
	const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
		onChange(e.target.value);
	};

	return (
		<Stack width={'100%'} gap={'8px'}>
			{title && (
				<Typography textAlign={'center'} variant={'answerText'}>
					{title}
				</Typography>
			)}
			<TextField
				value={value}
				size={'small'}
				hiddenLabel
				autoComplete={'off'}
				error={!isValid && required}
				onChange={handleInputChange}
				variant={variant}
				slotProps={{
					input: {
						className: styles.container,
						startAdornment: startIcon ? (
							<InputAdornment position="start">{startIcon}</InputAdornment>
						) : null,
						endAdornment: endIcon ? <InputAdornment position="end">{endIcon}</InputAdornment> : null,
					},
				}}
				{...rest}
			/>
			{!isValid && required && (
				<Stack direction={'row'} gap={'4px'} alignItems={'center'}>
					<ExclamationMarkIcon />
					<Typography fontSize={'14px'} sx={{ color: '#C02020' }}>
						{errorMessage}
					</Typography>
				</Stack>
			)}
		</Stack>
	);
};
